import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Notfound } from './app/pages/notfound/notfound';
import { AuthGuard } from './app/layout/guard/auth.guard';
import { User } from './app/pages/user/user';
import { Section } from './app/pages/sections/section';
import { Category } from './app/pages/categories/category';
import { Result } from './app/pages/osce/result/result';
import { ParticipantChecklistHistory } from './app/pages/osce/result/participant_history';
import { Form } from './app/pages/osce/form/form';
import { Preview } from './app/pages/osce/form/preview';
import { Tutor } from './app/pages/osce/tutor/tutor';
import { TutorHistory } from './app/pages/osce/tutor/tutor_history';
import { Timer } from './app/pages/osce/timer/timer';
import { FormQuiz } from './app/pages/osce/form-quiz/form-quiz';
import { Answer } from './app/pages/osce/form-answer/answer';
import { History } from './app/pages/osce/form-answer/history';
import { Simulation } from './app/pages/simulation/simulation';
import { Packages } from './app/pages/osce/packages/package';
import { Room } from './app/pages/simulation/room';
import { StartSimulation } from './app/pages/simulation/start';
import { SimulationHistory } from './app/pages/simulation/history';
import { Login } from './app/pages/auth/login';
import { SheetCases } from './app/pages/osce/sheet/sheet_cases';
import { Sheet } from './app/pages/osce/sheet/sheet';
import { SheetAnswer } from './app/pages/osce/sheet/sheet_answer';
import { SheetHistory } from './app/pages/osce/sheet/sheet_history';
import { SheetTutor } from './app/pages/osce/sheet/sheet_tutor';
import { SheetUserAnswer } from './app/pages/osce/sheet/sheet_user_answer';
import { SheetUserAnswerDetail } from './app/pages/osce/sheet/sheet_user_answer_detail';
import { CreateAnatomi } from './app/pages/anatomi/create-anatomi';
import { ListAnatomi } from './app/pages/anatomi/list-anatomi';
import { EditAnatomi } from './app/pages/anatomi/edit.anatomi';
import { Anatomi } from './app/pages/anatomi/anatomi';
import { AnatomyDetails } from './app/pages/anatomi/anatomi-details';
import { HistoryAnatomy } from './app/pages/anatomi/history-anatomy';
import { Quiz } from './app/pages/quiz/quiz';
import { UserProfileComponent } from './app/pages/user/profile';
import { CreateVideoMaterial } from './app/pages/video_material/create';
import { ListVideoMaterial } from './app/pages/video_material/list';
import { EditVideoMaterial } from './app/pages/video_material/edit';
import { ShowVideoMaterial } from './app/pages/video_material/show';
import { VideoMaterialPage } from './app/pages/video_material/page';
import { NotesIndex } from './app/pages/notes/index';
import { NotesCreate } from './app/pages/notes/create';
import { NotesUpdate } from './app/pages/notes/update';
import { TestimonyVideo } from './app/pages/testimonies/testimony_video';
import { TestimonyImage } from './app/pages/testimonies/testimony_image';
import { NotesShow } from './app/pages/notes/show';
import { FlashcardKategori } from './app/pages/flashcard/flashcard_kategori';
import { FlashcardComponent } from './app/pages/flashcard/flashcard';
import { FlashcardShowComponent } from './app/pages/flashcard/flashcard_show';
import { ArticlePage } from './app/pages/article/page';
import { CreateArticle } from './app/pages/article/create';
import { ListArticle } from './app/pages/article/list';
import { ShowArticle } from './app/pages/article/show';
import { EditArticle } from './app/pages/article/edit';

export const appRoutes: Routes = [
    { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
    {
        path: 'app',
        component: AppLayout,
        canActivate: [AuthGuard],
        children: [
            { path: 'dashboard', component: Dashboard },
            { path: 'quiz', component: Quiz },
            { path: 'users', component: User },
            { path: 'profile', component: UserProfileComponent },
            { path: 'sections', component: Section },
            { path: 'categories', component: Category },
            { path: 'osce/result', component: Result },
            { path: 'osce/result/participant-history', component: ParticipantChecklistHistory },
            { path: 'osce/form', component: Form },
            { path: 'osce/preview', component: Preview },
            { path: 'osce/tutor', component: Tutor },
            { path: 'osce/tutor/history', component: TutorHistory },
            { path: 'osce/form/ekg', component: FormQuiz },
            { path: 'osce/form/answer', component: Answer },
            { path: 'osce/form/answer/history', component: History },
            { path: 'osce/simulation', component: Simulation },
            { path: 'osce/simulation/history/:code', component: SimulationHistory },
            { path: 'osce/simulation/history', component: SimulationHistory },
            { path: 'osce/simulation/room/:code', component: Room, canDeactivate: [AuthGuard] },
            { path: 'osce/simulation/start/:code', component: StartSimulation, canDeactivate: [AuthGuard] },
            { path: 'osce/packages', component: Packages },
            { path: 'osce/sheet/cases', component: SheetCases },
            { path: 'osce/sheet/history', component: SheetHistory },
            { path: 'osce/sheet/penguji', component: SheetTutor },
            { path: 'osce/sheet/user/answer/:id', component: SheetUserAnswer },
            { path: 'osce/sheet/user/answer/detail/:id', component: SheetUserAnswerDetail },
            { path: 'osce/anatomi/create', component: CreateAnatomi },
            { path: 'osce/anatomi/list', component: ListAnatomi },
            { path: 'osce/anatomi/edit/:id', component: EditAnatomi },
            { path: 'osce/anatomi/details/:id', component: AnatomyDetails },
            { path: 'osce/anatomi', component: Anatomi },
            { path: 'osce/anatomi/history', component: HistoryAnatomy },
            { path: 'video_material', component: VideoMaterialPage },
            { path: 'video_material/create', component: CreateVideoMaterial },
            { path: 'video_material/list', component: ListVideoMaterial },
            { path: 'video_material/show/:id', component: ShowVideoMaterial },
            { path: 'video_material/edit/:id', component: EditVideoMaterial },
            { path: 'testimonies/video', component: TestimonyVideo },
            { path: 'testimonies/image', component: TestimonyImage },
            { path: 'notes', component: NotesIndex },
            { path: 'notes/create', component: NotesCreate },
            { path: 'notes/show/:id', component: NotesShow },
            { path: 'notes/update/:id', component: NotesUpdate },
            { path: 'flashcard', component: FlashcardKategori },
            { path: 'flashcards', component: FlashcardComponent },
            { path: 'flashcard/show', component: FlashcardShowComponent },
            { path: 'flashcard/show/:id', component: FlashcardShowComponent },
            { path: 'article', component: ArticlePage },
            { path: 'article/create', component: CreateArticle },
            { path: 'article/list', component: ListArticle },
            { path: 'article/show/:id', component: ShowArticle },
            { path: 'article/edit/:id', component: EditArticle },
            { path: 'osce/timer', component: Timer },
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: 'osce/sheet', component: Sheet, canActivate: [AuthGuard] },
    { path: 'osce/sheet/answer/:id', component: SheetAnswer, canActivate: [AuthGuard] },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];

